import { OS } from "@/lib/utils/platform/detectOS.types";

export default function () {
  if (/android/i.test(navigator.userAgent)) {
    return OS.android;
  } else if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
    return OS.iOS;
  }

  return OS.other;
}
